// HomePage.js - Full API Integration with Inline Comments

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function HomePage({ apiRoutes }) {
  const [clients, setClients] = useState([]);
  const [filters, setFilters] = useState({
    agentName: "",
    clientName: "",
    enterDate: ""
  });
  const navigate = useNavigate();

  // Fetch all clients from the server
  useEffect(() => {
    const fetchClients = async () => {
      try {
        const params = new URLSearchParams();
        if (filters.agentName) params.append("agentName", filters.agentName);
        if (filters.clientName) params.append("clientName", filters.clientName);
        if (filters.enterDate) params.append("enterDate", filters.enterDate);

        const url = `${apiRoutes.getClients}${params.toString() ? "?" + params.toString() : ""}`;
        const response = await fetch(url);
        const data = await response.json();
        setClients(data);
      } catch (error) {
        console.error("Failed to fetch clients:", error);
      }
    };
    fetchClients();
  }, [apiRoutes, filters]);

  // Handle deleting a client (API call)
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this client?")) {
      try {
        const response = await fetch(apiRoutes.deleteClient(id), { method: "GET" });
        const result = await response.json();

        if (result.success) {
          setClients(clients.filter(client => client.id !== id));
        } else {
          alert("Failed to delete client.");
        }
      } catch (error) {
        console.error("Failed to delete client:", error);
        alert("Error deleting client.");
      }
    }
  };

  // Handle filter changes
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  return (
    <div>
      <h1>Client Tour Management</h1>
      <button onClick={() => navigate("/add")}>Add New Client Tour</button>

      {/* Filters */}
      <div style={{ margin: "20px 0" }}>
        <input
          type="text"
          name="agentName"
          placeholder="Filter by Agent Name"
          value={filters.agentName}
          onChange={handleFilterChange}
          style={{ marginRight: "10px" }}
        />
        <input
          type="text"
          name="clientName"
          placeholder="Filter by Client Name"
          value={filters.clientName}
          onChange={handleFilterChange}
          style={{ marginRight: "10px" }}
        />
        <input
          type="date"
          name="enterDate"
          placeholder="Filter by Entering Date"
          value={filters.enterDate}
          onChange={handleFilterChange}
        />
      </div>

      {/* Display all client tours */}
      <div className="client-list">
        {clients.length > 0 ? (
          clients.map((client) => (
            <div key={client.id} className="client-card">
              <h3>{client.client_name}</h3>
              <p>Agent: {client.agent_name}</p>
              <p>Entering Date: {client.enter_date ? new Date(client.enter_date).toLocaleString() : ""}</p>

              {/* Display Passport Photo if available */}
              {client.passport_photo && (
                <img src={client.passport_photo} alt="Passport" style={{ maxWidth: "150px" }} />
              )}

              <div className="client-actions">
                <button onClick={() => navigate(`/view/${client.id}`)}>View</button>
                <button onClick={() => handleDelete(client.id)}>Delete</button>
              </div>
            </div>
          ))
        ) : (
          <p>No clients found.</p>
        )}
      </div>
    </div>
  );
}

export default HomePage;
